var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex" },
    [
      _c(
        "div",
        { staticClass: "flex-shrink-0", style: { paddingRight: "37.5rem" } },
        [
          _c(
            "div",
            {
              staticClass:
                "sticky left-0 z-30 flex items-center justify-between px-6 h-14 top-24 bg-slate-300",
              style: { width: "calc(100vw - 37.5rem - 0.5rem)" }
            },
            [
              _c(
                "div",
                [
                  _c("BlTextBody2", {
                    attrs: {
                      text:
                        "Showing " +
                        _vm.bookingTimeslots.length +
                        " appointment schedule(s)"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex items-center gap-2" },
                [
                  _c(
                    "div",
                    [
                      _c("BlSelectBox", {
                        attrs: { options: _vm.timeslotViewOptions, dense: "" },
                        on: {
                          change: function($event) {
                            return _vm.$emit("set-timeslot-view", $event)
                          }
                        },
                        model: {
                          value: _vm.timeslotView,
                          callback: function($$v) {
                            _vm.timeslotView = $$v
                          },
                          expression: "timeslotView"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("BlTextBody2", { attrs: { text: _vm.masterDate } })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sticky z-20 flex h-12 top-38 bg-slate-200" },
            [
              _c("div", {
                staticClass:
                  "sticky left-0 z-10 flex-shrink-0 w-20 h-12 border-b bg-slate-200 border-slate-400"
              }),
              _vm._v(" "),
              _vm._l(_vm.headers, function(n, idx) {
                return _c(
                  "div",
                  {
                    key: idx,
                    staticClass:
                      "flex items-center justify-center flex-shrink-0 h-12 px-2 py-1 border-b border-slate-400",
                    style: { width: "calc(" + _vm.slotWidth + ")" }
                  },
                  [
                    n.highlight
                      ? _c(
                          "div",
                          { staticClass: "flex items-center gap-1 h-7" },
                          [
                            _c("BlTextBody2", {
                              attrs: { text: n.label.split(" ")[0] }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex items-center justify-center rounded-full h-7 w-7 bg-light-purple-400"
                              },
                              [
                                _c("BlTextBody2", {
                                  staticClass: "text-pure-white",
                                  attrs: { text: n.label.split(" ").pop() }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "px-4 truncate h-7",
                            attrs: { title: n.label }
                          },
                          [
                            _c("BlTextBody2", {
                              staticClass: "truncate",
                              attrs: { text: n.label }
                            })
                          ],
                          1
                        )
                  ]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "relative flex flex-col bg-slate-200" },
            _vm._l(_vm.clockRound, function(time) {
              return _c(
                "div",
                {
                  key: time,
                  staticClass: "flex",
                  attrs: { id: "recurring_time_view_" + time }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "sticky left-0 z-10 flex justify-end flex-shrink-0 w-20 px-3 py-2 transition-all duration-300 border-b border-r bg-slate-200 border-slate-400",
                      style: { height: _vm.slotHeight * 2 + "rem" }
                    },
                    [_c("BlTextBody2", { attrs: { text: time } })],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.headers, function(n, idx) {
                    return _c("div", {
                      key: idx,
                      staticClass:
                        "flex flex-col items-center justify-center flex-shrink-0 gap-2 transition-all duration-300 border-b border-r border-slate-400 bg-slate-200",
                      style: {
                        height: _vm.slotHeight * 2 + "rem",
                        width: "calc(" + _vm.slotWidth + ")"
                      }
                    })
                  })
                ],
                2
              )
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "fixed z-50 flex-shrink-0 overflow-y-auto border top-24 right-2 bg-pure-white border-slate-400 scrollbar-lg",
          style: {
            height: "calc(100vh - 6rem - 5rem - 0.5rem)",
            width: "37.5rem"
          }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "sticky top-0 z-10 flex flex-col gap-1 px-6 py-4 border-b bg-pure-white border-slate-400"
            },
            [
              _c("BlTextSubtitle1", {
                attrs: { text: "Manage timeslots and set recurrence" }
              }),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("BlTextBody2", {
                    staticClass: "text-slate-800",
                    attrs: {
                      text:
                        "You are now creating weekly recurring schedules for "
                    }
                  }),
                  _vm._v(" "),
                  _vm.client
                    ? _c("BlTextSubtitle3", {
                        staticClass: "text-slate-800",
                        attrs: { text: _vm.client.name + ". " }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    staticClass: "text-slate-800",
                    attrs: {
                      text:
                        "Below, you can review and add additional timeslots, and configure the recurrence settings."
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex flex-col gap-3 px-6 pt-4 pb-54" },
            [
              _c("BlTextSubtitle1", { attrs: { text: "Manage timeslots" } }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "grid items-center grid-cols-2 gap-4" },
                [
                  _c("BlInputButton", {
                    attrs: {
                      type: "outlined",
                      dense: "",
                      label: "Select from previous schedule"
                    },
                    on: {
                      clicked: function($event) {
                        return _vm.$emit("open-previous")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("BlInputButton", {
                    attrs: { icon: "plus", dense: "", label: "Add a timeslot" },
                    on: {
                      clicked: function($event) {
                        return _vm.$emit("add-timeslot")
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("BlTextBody2", {
                attrs: {
                  text: _vm.bookingTimeslots.length + " timeslot(s) added"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { key: "timeslots_" + _vm.bookingTimeslots.length },
                _vm._l(_vm.bookingTimeslots, function(timeslot, idx) {
                  return _c("ItemTimeslot", {
                    key: timeslot.key,
                    attrs: {
                      timeslot: timeslot,
                      isPattern: "",
                      deleteDisabled: idx === 0,
                      useEdit: "",
                      useStartsFrom: ""
                    },
                    on: {
                      edit: function($event) {
                        return _vm.$emit("edit-timeslot", timeslot)
                      },
                      delete: function($event) {
                        return _vm.$emit("delete-timeslot", $event)
                      }
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "fixed z-10 flex flex-col gap-3 px-6 py-4 border-t bottom-22 bg-pure-white border-slate-400",
              style: { width: "36.75rem" }
            },
            [
              _c("BlTextSubtitle1", { attrs: { text: "Recurrence settings" } }),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-col gap-2" }, [
                _c("div", { staticClass: "flex gap-4" }, [
                  _c(
                    "div",
                    {
                      staticClass: "flex items-center flex-shrink-0 h-11 w-34"
                    },
                    [
                      _c("BlTextSubtitle3", { attrs: { text: "Repeat every" } })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex items-center gap-2 h-11" },
                    [
                      _c("BlInputText", {
                        staticClass: "w-16",
                        attrs: { input: _vm.intervalInput },
                        on: { changed: _vm.onInputInterval }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        staticClass: "text-slate-800",
                        attrs: { text: "week(s)" }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex gap-4" }, [
                  _c(
                    "div",
                    {
                      staticClass: "flex items-center flex-shrink-0 h-11 w-34"
                    },
                    [
                      _c("BlTextSubtitle3", {
                        attrs: { text: "Total appointments" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex-col gap-2" }, [
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-3 h-11" },
                      [
                        _c("BlInputRadio", {
                          attrs: {
                            name: "end_after",
                            checked:
                              _vm.endAfterInput === "based_on_available_credits"
                          },
                          on: {
                            changed: function($event) {
                              _vm.endAfterInput = "based_on_available_credits"
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          attrs: { text: "Based on available credits" }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex items-center px-4 border rounded h-11 bg-slate-200 border-slate-500"
                          },
                          [
                            _c("BlTextBody2", {
                              attrs: {
                                text: _vm.availableCredits + " credit(s)"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-3 h-11" },
                      [
                        _c("BlInputRadio", {
                          attrs: {
                            name: "end_after",
                            checked: _vm.endAfterInput === "appointment_count"
                          },
                          on: {
                            changed: function($event) {
                              _vm.endAfterInput = "appointment_count"
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("BlInputText", {
                          staticClass: "self-start w-16",
                          attrs: { input: _vm.appointmentCountInput },
                          on: { changed: _vm.onInputAppointmentCount }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", { attrs: { text: "appointment(s)" } })
                      ],
                      1
                    )
                  ])
                ])
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.existingSlots, function(slot, idx) {
        return _c("SlotRecurring", {
          key: idx + "_" + slot.id,
          attrs: {
            isCompact: _vm.timeslotView === "compact",
            period: slot.period,
            therapist: slot.user,
            room: slot.room,
            position: slot.position,
            assets: slot.assets,
            error: slot.error
          }
        })
      }),
      _vm._v(" "),
      _vm._l(_vm.existingAppointments, function(slot, idx) {
        return _c("SlotRecurring", {
          key: idx + "_" + slot.id,
          style: { zIndex: 1 },
          attrs: {
            isCompact: _vm.timeslotView === "compact",
            period: slot.period,
            therapist: slot.user,
            room: slot.room,
            position: slot.position,
            assets: slot.assets
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a140512", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a140512","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointments/overlay/ManageScheduleRecurring.vue
// module id = null
// module chunks = 